<template>
  <div>
    <div class=" w-full mt-2">
      <p class="font-black text-xs mb-2 uppercase">
         Other Benefits
      </p>
      <div class="line"></div>
    </div>
    <table aria-label="other benefits table" class=" w-full">
      <thead>
        <tr>
          <th id="0">#</th>
          <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in otherBenefitData" :key="i" class="tableBody text-sm" style="height: 48px; ">
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ data.payItem.name }}
          </td>
          <td>
            {{ Capitalize(data.payType) }}
          </td>
          <td>
            {{ data.rateType.label }}
          </td>
          <td>
            <span>
              {{`${data.rateValue}%`}}
            </span>
          </td>
          <td>
            {{ convertToCurrency(data.actualAmount) }}
          </td>
        </tr>
        <tr class="h-7" />
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    otherBenefitData: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      headers: [
        { title: "pay item" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "rate (%)" },
        { title: "amount (₦)" },
      ]
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 10px auto;
  border-radius: 10px;
  padding: 0;
}
</style>
